<template>
  <v-card class="d-flex pa-4 flex-column" outlined>
    <v-alert
      v-model="flashError"
      dense
      border="left"
      type="error"
      dismissible
      elevation="2"
    >
      {{ flashErrorMessage }}
    </v-alert>
    <TableSearchFilter
      :search="{ rrn: '', nmid: '', mid: '' }"
      @search="updateSearch" 
      @showType="showType"
      :filters="[
        { key: 'rrn', type: 'textfield', props: { label: 'RRN *' } },
        { key: 'nmid', type: 'textfield', props: { label: 'NMID' } },
        { key: 'mid', type: 'textfield', props: { label: 'MID' } },
      ]"
    />
    <TableView
      :headers="headers"
      :items="allData"
      :options.sync="options"
      :loading="loading"
      :selected-items="selectedData"
      :totalData="totalData"
      :refresh-table="refeshTable"
      item-key="id"
      table-height="70vh"
      @select-row="selectRow"
      @view-detail="viewDetail"
      @clear-selected="clearSelected"
    >
    <template slot="action" slot-scope="{ item }">
      <div class="d-flex justify-center align-center" style="height: 100%">
        <v-icon
          @click="viewDetail(item.id)"
          size="20"
        >
          mdi-eye
        </v-icon>
      </div>
    </template>
    </TableView>
  </v-card>
</template>

<script>
import { headers, search, editedItem} from '../../components/insert-transaction-on-us/history-insert-transaction/attributes';
import { getDate, date, showAlert } from '../../lib/helpers';

export default {
  components: {
    TableView: () => import("../../components/@drontVue/components/Table/TableView.vue"),
    TableSearchFilter: () => import("../../components/@drontVue/components/SearchFilter/TableSearchFilter.vue"),
  },
  data: () => ({
    options: {},
    show: false,
    dialog: false,
    dialogConfirm: false,
    headers,
    search,
    editedItem,
    defaultItem: {},
    selectedRow: null,
    editedIndex: -1,
    selectedData: [],
    selectAllData: false,
    isResetData: true,
  }),

  computed: {
    allData() {
      return this.$store.state.historyTransactionOnUs.allData;
    },
    totalData() {
      return this.$store.state.historyTransactionOnUs.totalData;
    },
    totalPage() {
      return this.$store.state.historyTransactionOnUs.totalPage;
    },
    loading() {
      return this.$store.state.historyTransactionOnUs.loading;
    },
    flashError: {
      get() {
        return this.$store.state.historyTransactionOnUs.flashError;
      },
      set() {
        this.$store.commit('historyTransactionOnUs/setFlashErrorMessage', '');
      },
    },
    flashErrorMessage() {
      return this.$store.state.historyTransactionOnUs.flashErrorMessage;
    },
  },

  watch: {
    options: {
      handler() {
        this.getData();
      },
    },

    selectedData: {
      handler() {
        this.checkAllSelected();
      },
    },
  },

  methods: {
    selectRow(index) {
      if (this.selectedRow !== index) {
        this.selectedRow = index;
      } else {
        this.selectedRow = '';
      }
    },

    viewDetail(id) {
      this.$router.push(`/insert-transaction-on-us/history-insert-transaction/detail/${id}`);
    },

    rowClass() {
      const rowClass = 'max-width-col';

      return rowClass;
    },

    truncateTextByChar(text, maxLength) {
      if (!text) return '';
      if (text.length > maxLength) {
        return `${text.slice(0, maxLength)  }...`;
      }

      return text;
    },

    updateSearch(newSearch) {
      this.search.rrn = newSearch.rrn || ''; 
      this.search.nmid = newSearch.nmid || ''; 
      this.search.mid = newSearch.mid || '';

      this.options.page = 1;
      this.getData(); 
    },
    showType(newSearch) {
      if ((!newSearch || !newSearch.rrn)) {
        this.$vuetify.goTo(0);
        showAlert(this.$store, 'RRN required !', 'mdi-alert', 'red');
      } else {
        this.clearSelected();
        this.search.rrn = newSearch.rrn; 
        this.search.nmid = newSearch.nmid || '';
        this.search.mid = newSearch.mid || '';
        this.options.page = 1;
        this.getData(); 
      }
    },

    getData() {
    
      this.$store.commit('historyTransactionOnUs/setFlashErrorMessage', '');
      const { page, itemsPerPage, sortBy, sortDesc } = this.options;

      this.$store
        .dispatch('historyTransactionOnUs/getData', {
          date,
          page,
          itemsPerPage,
          sortBy,
          sortDesc,
          search: this.search,
        })
        .then(() => {
          if (this.totalPage < page) {
            this.options.page = this.totalPage === 0 ? 1 : this.totalPage;
          }
        })
        .finally(() => {
          this.checkAllSelected();
        });
      
    },

    refeshTable() {
      this.getData();
    },

    close() {
      this.dialog = false;
      this.dialogConfirm = false;
      this.$nextTick(() => {
        this.editedItem = { ...this.defaultItem };
        this.editedIndex = -1;
      });
    },

    closeFlash() {
      this.$store.commit('historyTransactionOnUs/setFlashErrorMessage', '');
    },

    clearSearch() {
      this.search.nmid = '';
      this.search.mid = '';
      this.search.mid_bank = '';
      this.search.rrn = '';
      this.search.payment_channel = '';
      this.search.mpan = '';
      this.search.trx_date = '';
      this.search.trx_time = '';
    },

    formatDate(dateVal) {
      if (!dateVal) return null;

      const [year, month, day] = dateVal.split('-');

      return `${day}/${month}/${year}`;
    },
    parseDate(dateVal) {
      if (!dateVal) return null;

      const [day, month, year] = dateVal.split('/');

      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    },

    clearSelected() {
      this.selectedData = [];
      this.selectAllData = false;
    },

    selectAll(status) {
      this.$nextTick(() => {
        const allIds = this.allData.map((val) => val.id);
        const filtered = allIds.filter(
          (val) => !this.selectedData.includes(val)
        );

        if (status) {
          this.selectedData = this.selectedData.concat(filtered);
        } else {
          this.selectedData = this.selectedData.filter(
            (val) => !allIds.includes(val)
          );
        }
      });
    },

    checkAllSelected() {
      const allIds = this.allData.map((val) => val.id);
      const allSelected = allIds.filter(
        (val) => !this.selectedData.includes(val)
      );

      if (
        allSelected.length === 0 &&
        this.selectedData.length > 0 &&
        this.allData.length > 0
      ) {
        this.selectAllData = true;
      } else {
        this.selectAllData = false;
      }
    },
    getDate,
  },
  beforeRouteLeave(to, from, next) {
    this.clearSearch();
    next();
  },
};
</script>

<style>
.max-width-col td {
  white-space: nowrap;
  overflow: hidden;
  max-width: 250px;
  text-overflow: ellipsis;
}
.v-data-table .v-data-table__wrapper {
  height: 100%;
}
</style>
